
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
components: {
Tabbar,
TabbarItem,
}
}



// WEBPACK FOOTER //
// ./src/components/FootBar.vue